<template>
  <section > 
    <b-row> 
      <b-col  class="box-effect linear" >
            <validation-observer v-slot="{ invalid } ">    
              <b-card> 
                  <template v-slot:header >       
                    <div class="header-card">
                      Ficha del Afiliado {{dataForm[namePath].datos_afiliado.nombre1}} {{dataForm[namePath].datos_afiliado.nombre2}} {{dataForm[namePath].datos_afiliado.apellido1}} {{dataForm[namePath].datos_afiliado.apellido2}} 
                    </div>                              
                  </template>                  
                  <b-form  inline style="margin-bottom:15px;" novalidate>
                    <b-row style="width:100%"  align-v="center"> 
                      <sw-searchs
                      :md="6"
                      :lg="6"
                      style="margin-top:10px"
                      label='Seleccionar afiliado'
                      list='datos_afiliado'
                      @input="watchAfiliado"
                      filterCampos="documento"
                      :filter="{campo: 'servicios', value: 0}"
                      >
                      </sw-searchs> 
                      <b-col>
                        <b-button @click="onInit()" style="margin-top:28px" size="sm">Limpiar</b-button>    
                        <!-- <b-button @click="empalme_archivos()" style="margin-top:28px;margin-left:200px" size="sm">EMPALME DE ARCHIVOS NO DAR CLICK</b-button> -->
                      </b-col>                   
                    </b-row> 
                    <div style="width:100%" class="p-2 mt-4" v-if="searchSw.value!=='' && dataForm[namePath].datos_afiliado.id!==null">
                      <b-nav tabs style="width:100%">
                        <b-nav-item :active="active===0" @click="changeActive(0)" >Ficha</b-nav-item>
                        <b-nav-item :active="active===1" @click="changeActive(1)" >Documentos</b-nav-item>
                        <b-nav-item :active="active===2" @click="changeActive(2)" >Beneficiarios</b-nav-item>
                        <b-nav-item :active="active===3" @click="changeActive(3)" >Afiliaciones</b-nav-item>
                        <b-nav-item :active="active===4" @click="changeActive(4)" >Aportes</b-nav-item>
                        <b-nav-item :active="active===5" @click="changeActive(5)" >Incapacidades</b-nav-item>
                      </b-nav> 
                      <div v-show="active===0" style="border:1px solid; border-top:none;border-color: #dee2e6;width:100% ">
                        <b-row >                     
                          <b-col md="12">
                            <h5 class="title-form">Datos Personales</h5>
                            <b-button size="sm" style="position:absolute;right:15px;top:25px" @click="fichaPrint">Imprimir Ficha</b-button>
                            <b-row  class="row-inputs">
                              <sw-inputs
                                  v-if="user.admin===1"
                                  inputTabla="datos_afiliado"
                                  inputCampo="id_list_estado"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs> 
                              <b-col :md="6"
                                  :lg="3" v-else>
                                  <span style="display:block;margin-top:15px;font-size: inherit;padding-bottom: 3px !important;color: rgb(85, 85, 85);">Estado</span>
                                {{gettersDatalist('list_estado',dataForm[namePath].datos_afiliado.id_list_estado)[0].name}}
                              </b-col>
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="id_list_documento"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>  
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="documento"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>     
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="nacimiento"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>                   
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="nombre1"
                                  :md="6"
                                  :lg="3"
                                >       
                              </sw-inputs>                            
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="nombre2"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>                                    
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="apellido1"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>                       
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="apellido2"
                                  :md="6"
                                  :lg="3"
                                >
                              </sw-inputs>               
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="email"
                                  :md="6"
                                  :lg="6"
                                >
                              </sw-inputs>                            
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="direccion"
                                  :md="6"
                                  :lg="6"
                                >
                              </sw-inputs>                     
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="ciudad"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>               
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="telefonos"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>           
                              <sw-inputs
                                  inputTabla="datos_afiliado"
                                  inputCampo="referido"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>        
                              <sw-inputs
                                  v-if="dataForm[namePath].datos_afiliado.referido!==null"
                                  inputTabla="descuentos_referido"
                                  inputCampo="descuento"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>          
                              <sw-inputs
                                  style="margin-top: 15px"
                                  inputTabla="datos_afiliado"
                                  inputCampo="planilla"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>           
                              <sw-inputs
                                  style="margin-top: 15px"
                                  inputTabla="info_afiliacion"
                                  inputCampo="prioridad"
                                  :md="3"
                                  :lg="3"
                                >
                              </sw-inputs>         
                            </b-row>
                          </b-col>   
                          <b-col md="12">
                            <h5 class="title-form">Datos afiliación</h5>
                            <b-row class="row-inputs"> 
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_datos_razon"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>            
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="ingreso"
                                  @input="changeIngreso"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>      
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="mes_periodo"
                                  @input="changeIngreso();changeAporte()"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>        
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="ano_periodo"
                                  @input="changeIngreso();changeAporte()"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>   
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_list_novedad"
                                  @input="changeIngreso"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>  
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="dias"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="salario"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs> 
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="cargo"
                                  :md="6"
                                  :lg="3"
                                  >
                                </sw-inputs>  
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_datos_asesor" 
                                  :md="6"
                                  :lg="3"  >
                                </sw-inputs>                           
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_datos_contacto" 
                                  :md="6"
                                  :lg="3"  >
                                </sw-inputs>
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="exonerado"
                                  :md="6"
                                  :lg="6"
                                  >
                                </sw-inputs> 
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_list_tipo"
                                  :filter="{filter: active}"
                                  :md="12"
                                  :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="id_list_subtipo"
                                  :filter="{filter: dataForm[namePath].info_afiliacion.id_list_tipo}"
                                  :md="12"
                                  :lg="6">
                                </sw-inputs>
                            </b-row>
                          </b-col> 
                          <b-col  md="12"  v-if="searchSw.value!==''">
                            <h5 class="title-form">Servicios</h5>
                            <b-row>
                              <!--<sw-tablemultiple
                                v-if="user.admin===0"
                                style="padding:0;"
                                class="tablemultiple-white"
                                getTable="multiple_servicios"
                                :views="[
                                  { th:'Servicio', td: 'name'},
                                  { th:'Entidad', td: 'id_list', style: 'width: 143px',disabled:false},
                                  { th:'Inicio L.', td: 'iniciolabores'},
                                  { th:'Afiliación', td: 'afiliacion'},
                                  { th:'Mes aporte', td: 'mes_periodo', list: 'list_mes',disabled:true},
                                  { th:'Año aporte', td: 'ano_periodo', list: 'list_ano',disabled:true},
                                  { th:'Valor', td: 'valor'},
                                ]"
                                readonly
                                >
                              </sw-tablemultiple>-->
                              <sw-tablemultiple
                                style="padding:0;"
                                class="tablemultiple-white"
                                getTable="multiple_servicios"
                                :views="[
                                  { th:'Select.', td: 'check'},
                                  { th:'Servicio', td: 'name'},
                                  { th:'Entidad', td: 'id_list'},
                                  { th:'Inicio L.', td: 'iniciolabores', style: 'width: 143px'},
                                  { th:'Afiliación', td: 'afiliacion'},
                                  { th:'Mes aporte', td: 'mes_periodo', list: 'list_mes'},
                                  { th:'Año aporte', td: 'ano_periodo', list: 'list_ano',},
                                  { th:'Valor', td: 'valor'},
                                ]"
                                >
                              </sw-tablemultiple>
                                <sw-inputs
                                  inputTabla="info_afiliacion"
                                  inputCampo="observacion"
                                  :md="12"
                                  :lg="12"
                                  >
                                </sw-inputs> 
                            </b-row>
                          </b-col>                                       
                        </b-row> 
                      </div>
                      <div v-if="active===1" style="border:1px solid; border-top:none;border-color: #dee2e6;width:100%;padding-bottom:30px;padding-top:30px ">
                        <b-row >
                          <b-col>
                            <sw-tableget
                              :tableItems="documentosItems"
                              :tableSearch="documentosSearch"
                              :filterShow="false"
                              name="tableGet1"
                              route="get_afldocumentos"
                              :dataRoute="{others: [['id_datos_afiliado',searchSw.value]]}"
                              @save="saveForm"
                              >   
                            </sw-tableget>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-if="active===2" style="border:1px solid; border-top:none;border-color: #dee2e6;width:100%;padding-bottom:30px;padding-top:30px ">
                        <b-row >
                          <b-col>
                             <sw-tableget
                              :tableItems="tableGBHISTItems"
                              :tableSearch="tableGBHISTSearch"
                              name="tableGet2"
                              route="get_inclusioneshist"
                              :dataRoute="{others: []}"
                              :filterShow="false"
                              @save="saveForm"
                              >  
                            </sw-tableget>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-if="active===3" style="border:1px solid; border-top:none;border-color: #dee2e6;width:100%;padding-bottom:30px;padding-top:30px ">
                        <b-row >
                          <b-col>
                             <sw-tableget
                              :tableItems="afiliacionesItems"
                              :tableSearch="afiliacionesSearch"
                              name="tableGet3"
                              route="get_aflficha"
                              :dataRoute="{ others: [['id_datos_afiliado',swSearchs.datos_afiliado.id]]}"
                              :filterShow="false"
                              @save="saveForm"
                              >  
                            </sw-tableget>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-if="active===4" style="border:1px solid; border-top:none;border-color: #dee2e6;width:100%;padding-bottom:30px;padding-top:30px ">
                        <b-row >
                          <b-col>
                             <sw-tableget
                              :tableItems="aportesItems"
                              :tableSearch="aportesSearch"
                              name="tableGet3"
                              route="get_aportesficha"
                              :dataRoute="{ others: [['id_datos_afiliado',swSearchs.datos_afiliado.id]]}"
                              :filterShow="false"
                              @save="saveForm"
                              >  
                            </sw-tableget>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                   </b-form>    
                   <sw-loading v-if="searchSw.value!='' && dataForm[namePath].datos_afiliado.id===null"></sw-loading>                 
                  <template v-if="searchSw.value!=='' && active===0" v-slot:footer>
                      <sw-saveform
                      :invalid="invalid"
                      :index="dataIndex[namePath]"
                      nameBtn="Ficha del Afiliado"
                      @save="saveForm">
                      </sw-saveform>   
                  </template>                                        
              </b-card>              
          </validation-observer>                   
      </b-col>      
    </b-row>
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modalafiliacion 
          v-if="openModal.modal.modal==='Afiliacion'"
          @save="saveForm"                     
          >
        </sw-modalafiliacion>  
        <sw-modalafiliaciongrupal 
          v-if="openModal.modal.modal==='AfiliacionGrupal'"
          @save="saveForm"                     
          >
        </sw-modalafiliaciongrupal>     
    </b-modal>
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwSaveform  from '@/components/forms/saveForm.vue'
import SwTablepost  from '@/components/dataTable/tablePost.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwMinform  from '@/components/forms/minform.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import SwModalafiliaciongrupal  from '@/components/modals/afiliacionGrupal.vue'
import { ValidationObserver } from 'vee-validate'
import SwSearchs from '@/components/forms/searchs.vue'
import SwLoading from '@/components/notification/loading.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'

export default { 
  name: "afiliacion_nueva",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
    SwInputs,     
    SwTablepost,
    SwSaveform,
    ValidationObserver,
    SwTablemultiple,
    SwMinform,
    SwModalafiliacion,
    SwModalafiliaciongrupal,
    SwSearchs,
    SwLoading,
    SwTableget
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
.tablemultiple-white table 
{
  background: white;
}
</style>